import React from 'react';
import i18next from 'i18next';
import Create from '../../rest/Create';
import Form from '../components/Form';

const UsersCreate = props => {
  const breadCrumb = [
    {
      title: i18next.t('orders.header'),
      path: '/orders',
    },
    {
      title: i18next.t('orders.createPage'),
      path: '/orders/create',
    },
  ]
  return (
    <Create {...props} resource="orders" breadCrumb={breadCrumb}>
      <Form />
    </Create>
  )
};

UsersCreate.propTypes = {};

export default UsersCreate;
